<template>
  <section class="charts">
    <highcharts class="chart" :options="barOptions" ref="barCharts"></highcharts>
  </section>
</template>
<script>
//import VueHighcharts from '../../src/VueHighcharts.vue'
import * as data from '../assets/js/chartdata'
export default {
  components: {
    //VueHighcharts,
  },
  data() {
    return {
      barOptions: {
          colors: ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE',
              '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'],  
          chart: {
              type: 'bar',
          },
          title: {
              text: '',
          },
          subtitle: {
              text:'',
          },
          xAxis: {
              categories: ['P1', 'P2', 'P3', 'P4', 'P5'],
              title: {
              text: null,
              },
          },
          yAxis: {
              min: 0,
              title: {
              text: 'EA',
              align: 'middle',
              },
              labels: {
              overflow: 'justify',
              },
          },
          tooltip: {
              valueSuffix: ' ea',
          },
          plotOptions: {
              bar: {
              dataLabels: {
                  enabled: true,
              },
              },
          },
          legend: {

          },
          credits: {
              enabled: false,
          },
          series: [
              {
              name: 'Type A',
              data: [107, 31, 635, 203, 2],
              },
              {
              name: 'Type B',
              data: [133, 156, 947, 408, 6],
              },
              {
              name: 'Type C',
              data: [1052, 954, 4250, 740, 38],
              },
          ], 
      },
      chartDataInterval: ''
    }
  },
  created () {    
    this.drawChart()
  },
  beforeDestroy () {
    clearInterval(this.chartDataInterval)
  },
  methods: {
    randomRange(n1, n2) {
      return Math.floor( (Math.random() * (n2 - n1 + 1)) + n1 )
    },
    updateChart () {
      this.chartDataInterval = setInterval(() => {       
        //console.log(chart)
        this.barOptions.series.forEach( i => {
          let vLength = this.barOptions.series[i].data.length
          let v = i.data[vLength-1]
          let rData = this.randomRange(1,3)
          i.data.push(v + rData)
        })      
      }, 1000)
    },
    drawChart () {
      this.barOptions.series.forEach( i => {
        let vLength = this.barOptions.series[i].data.length
        let v = i.data[vLength-1]
        let rData = this.randomRange(1,3)
        i.data.push(v + rData)
      })
    }
  }
}
</script>